// Replace: import { Link } from "react-router-dom";
import React, { useState } from "react";

const Nav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const linkClass =
    "relative inline-block before:content-[''] before:absolute before:left-0 before:-bottom-1 before:h-[2px] before:w-0 before:bg-white before:transition-all before:duration-300 hover:before:w-full";

  return (
    <nav className="bg-[#02347B] text-white shadow-md fixed top-0 left-0 w-full z-50">
      <div className="w-full px-4 md:px-14 py-4 md:py-5 flex items-center justify-between">
        <div className="flex items-center text-white font-bold text-2xl">
          <img src="logo.jpg" className="w-20" alt="Logo" />
        </div>

        <div className="hidden md:flex items-center space-x-6 Fira">
          <a href="#home" className={linkClass} onClick={handleLinkClick}>
            Home
          </a>
          <a href="#about" className={linkClass} onClick={handleLinkClick}>
            About Us
          </a>
          <a href="#product" className={linkClass} onClick={handleLinkClick}>
            Products
          </a>

          <div
            className="relative group"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <button
              className={linkClass}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              More ▾
            </button>
            {isDropdownOpen && (
              <div className="absolute bg-white text-black mt-1 py-2 rounded shadow w-48 z-50">
                <a
                  href="#industry"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  Industry
                </a>
                <a
                  href="#feature"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  Features
                </a>
                <a
                  href="#facility"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  Facilities
                </a>
                <a
                  href="#testimonial"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  Testimonials
                </a>
                <a
                  href="#contact"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  Contact
                </a>
                <a
                  href="#whychooseksu"
                  className="block px-4 py-2 hover:bg-gray-100"
                  onClick={handleLinkClick}
                >
                  Why Choose KSU
                </a>
              </div>
            )}
          </div>

          <button
            className="bg-[#3A72ED] hover:bg-[#264da1] transition-all duration-300 px-6 py-2 font-bold rounded-md"
            onClick={() =>
              window.open(
                "https://www.instagram.com/ksu.hinge?igsh=d3F1MzJlZXJnZXc2",
                "_blank"
              )
            }
          >
            Learn
          </button>
          <a
            href="https://wa.link/q71wx2"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-black hover:bg-zinc-400 transition-all duration-300 px-6 py-2 font-bold rounded-md inline-block text-center"
          >
            Join
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            ☰
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-blue-500 px-4 absolute w-full pb-4 space-y-2 top-0 left-0 z-40">
          <a href="#home" className="block py-2" onClick={handleLinkClick}>
            Home
          </a>
          <a href="#about" className="block py-2" onClick={handleLinkClick}>
            About Us
          </a>
          <a href="#product" className="block py-2" onClick={handleLinkClick}>
            Products
          </a>
          <div className="pl-4">
            <a
              href="#industry"
              className="block py-2"
              onClick={handleLinkClick}
            >
              Industry
            </a>
            <a href="#feature" className="block py-2" onClick={handleLinkClick}>
              Features
            </a>
            <a
              href="#facility"
              className="block py-2"
              onClick={handleLinkClick}
            >
              Facilities
            </a>
            <a
              href="#testimonial"
              className="block py-2"
              onClick={handleLinkClick}
            >
              Testimonials
            </a>
            <a href="#contact" className="block py-2" onClick={handleLinkClick}>
              Contact
            </a>
            <a
              href="#whychooseksu"
              className="block py-2"
              onClick={handleLinkClick}
            >
              Why Choose KSU
            </a>
          </div>
          <button
            className="w-full bg-blue-700 px-4 py-2 rounded-md text-white"
            onClick={handleLinkClick}
          >
            Learn
          </button>
          <button
            className="w-full bg-white text-black px-4 py-2 rounded-md"
            onClick={handleLinkClick}
          >
            Join
          </button>
        </div>
      )}
    </nav>
  );
};

export default Nav;
